import { matchPath } from 'react-router-dom'

const LOG = process.env.NODE_ENV === 'development'

const normalize = (routePath) => (
    typeof routePath === 'string' && routePath.length > 1 && routePath.endsWith('/')
        ? routePath.slice(0, -1)
        : routePath
)

const getPaths = (routeAccess) => {
    const paths = routeAccess && routeAccess.paths
    return Array.isArray(paths) && paths.length > 0 ? paths : null
}

export const isRouteAccessReady = (routeAccess) => (
    !!(routeAccess && routeAccess.fullAccess) || getPaths(routeAccess) !== null
)

export const hasRouteAccess = (path, exact, routeAccess) => {
    const settings = (routeAccess && routeAccess.settings) || {}
    if (settings.enabled === false) return true
    if (!path) return true

    if (routeAccess && routeAccess.fullAccess === true) return true

    const allowedPaths = getPaths(routeAccess)

    if (allowedPaths === null) {
        if (LOG) {
            console.warn('[route-access] access list khaali hai - seed aur /my-routes check karo.',
                settings.blockWhenUnavailable ? 'Sab band.' : 'Filhaal pages khole ja rahe hain.')
        }
        return !settings.blockWhenUnavailable
    }

    const allowed = new Set(allowedPaths.map(normalize))
    const routePaths = (Array.isArray(path) ? path : [path]).map(normalize)

    const isAllowed = routePaths.some(routePath => (
        (settings.allowParamRoutes && routePath.includes(':')) || allowed.has(routePath)
    ))

    if (!isAllowed && LOG) {
        console.warn(`[route-access] blocked "${routePaths.join(', ')}" - is user ko iska access nahi diya gaya`)
    }
    return isAllowed
}

const registeredRoutes = []

export const registerRoutePath = (path, exact) => {
    if (!path) return
    const routePaths = Array.isArray(path) ? path : [path]
    routePaths.forEach(routePath => {
        if (!registeredRoutes.some(route => route.path === routePath)) {
            registeredRoutes.push({ path: routePath, exact: exact !== false })
        }
    })
}

export const isKnownRoute = (pathname) => (
    registeredRoutes.some(route => !!matchPath(pathname, { path: route.path, exact: route.exact }))
)

export const getRegisteredRoutePaths = () => registeredRoutes.map(route => route.path)

const loggedDenials = new Set()

export const shouldLogDenial = (routePath) => {
    if (!routePath || loggedDenials.has(routePath)) return false
    loggedDenials.add(routePath)
    return true
}

export const clearDenialLog = () => loggedDenials.clear()
